import { render, staticRenderFns } from "./vigilance.vue?vue&type=template&id=4368a81d&scoped=true&"
import script from "./vigilance.vue?vue&type=script&lang=js&"
export * from "./vigilance.vue?vue&type=script&lang=js&"
import style0 from "./vigilance.vue?vue&type=style&index=0&id=4368a81d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4368a81d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard})
